// Стоп-кран и режим установки (033: contracts/api.md, «Стоп-кран»; data-model.md, `delivery.safety`;
// research Р1; принцип IV). Стоп-кран — состояние над всеми каналами: пока сообщения остановлены,
// любое письмо ждёт с причиной stopped (FR-007). Режим установки и список песочницы — настройки
// mailing.mode и mailing.sandbox; здесь — только их число для контролёра (адреса видит
// администратор клиента в «Настройки → Рассылка»).
import { z } from '../kernel/zod.ts';
import { TimestampSchema } from '../kernel/common.ts';

export const mailingModes = ['sandbox', 'live'] as const;
export type MailingMode = (typeof mailingModes)[number];
export const MailingModeSchema = z.enum(mailingModes);

export const mailingModeLabels = {
  sandbox: 'Песочница',
  live: 'Боевой режим',
} as const satisfies Record<MailingMode, string>;

/** Кто остановил — роль без ФИО (полоса «Все сообщения остановлены», FR-009). */
export const mailStopRoles = ['client_admin', 'controller'] as const;
export type MailStopRole = (typeof mailStopRoles)[number];

export const mailStopRoleLabels = {
  client_admin: 'администратор клиента',
  controller: 'контролёр',
} as const satisfies Record<MailStopRole, string>;

/** GET /api/delivery/safety, ответ «Остановить» и «Возобновить». */
export const MailSafetySchema = z.object({
  mode: MailingModeSchema,
  /** Адресов в списке песочницы. */
  sandboxCount: z.number().int().min(0),
  stopped: z
    .object({ at: TimestampSchema, role: z.enum(mailStopRoles) })
    .nullable(),
  /** Писем в очереди (queued) — для окна «Возобновить» и «Остановить». */
  queued: z.number().int().min(0),
});
export type MailSafety = z.infer<typeof MailSafetySchema>;
